import React from 'react';
import moment from 'moment';

import api from '../../api';
import { ICertificate } from '../../redux/models/certificates';
import CertificateItem from './CertificateItem';
import styles from './CertificateList.module.scss';

interface ICertificateList {
  certificates: ICertificate[];
  header?: string;
  openModal: (params: any) => void;
}

const CertificateList = (props: ICertificateList) => {
  const { certificates = [], header, openModal } = props;

  function downloadFile(certificateId: number) {
    return api.portal
      .downloadCertificate(certificateId)
      .then((response) => {
        return response.blob();
      })
      .then((blob) => URL.createObjectURL(blob))
      .then((url) => {
        let fileLink = document.createElement('a');
        fileLink.href = url;
        fileLink.download = `signedCert__${certificateId}.crt`;
        fileLink.click();
        URL.revokeObjectURL(url);
      });
  }

  return (
    <div>
      {header && <div className={styles.certificate_list__header}>{header}</div>}
      <div className={styles.certificate_list__items}>
        {certificates.map((c, i) => {
          const certId = c.id;
          const dateFormat = 'YYYY-MM-DD HH:mm:ss';
          const certCreationDate = moment.utc(c.creationDate).local().format(dateFormat);
          const certStatus = c.status;
          return (
            <div key={i} className={styles.certificate_list__item}>
              <CertificateItem
                key={certId}
                date={certCreationDate}
                status={certStatus}
                isExistBtn={certStatus === 'SIGNED'}
                onClick={() => downloadFile(certId)}
                onRevoke={() => openModal({ name: 'revoke CSR file', certId, certCreationDate })}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default CertificateList;
